document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.io-hotspot-section');

  sections.forEach(section => {
    const dots = section.querySelectorAll('.io-hotspot-dot');
    const accordions = section.querySelectorAll('.io-accordion-item');
    const toggleBtns = section.querySelectorAll('.io-toggle-btn');
    const images = section.querySelectorAll('.io-main-img');

    // 1. Function to activate a specific hotspot
    function activateHotspot(indexToActivate, isFromDot) {
      dots.forEach(dot => dot.classList.remove('is-active'));
      accordions.forEach(acc => acc.classList.remove('is-active'));

      if(dots[indexToActivate]) dots[indexToActivate].classList.add('is-active');
      if(accordions[indexToActivate]) {
        const targetAccordion = accordions[indexToActivate];
        targetAccordion.classList.add('is-active');

        // Auto-scroll on mobile
        if (isFromDot && window.innerWidth <= 900) {
          setTimeout(() => {
            const mediaHeight = section.querySelector('.io-hotspot-media').offsetHeight;
            const y = targetAccordion.getBoundingClientRect().top + window.pageYOffset - mediaHeight - 71 - 30;
            window.scrollTo({top: y, behavior: 'smooth'});
          }, 300);
        }
      }
    }

    // 2. Click listeners for Dots and Accordions
    dots.forEach(dot => {
      dot.addEventListener('click', function() {
        activateHotspot(this.getAttribute('data-index'), true);
      });
    });

    accordions.forEach(acc => {
      const header = acc.querySelector('.io-accordion-header');
      header.addEventListener('click', function() {
        activateHotspot(acc.getAttribute('data-index'), false);
      });
    });

    // 3. TOGGLE LOGIC (Classic vs Pocket)
    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        // Switch Active Button
        toggleBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const mode = btn.dataset.show; // 'classic' or 'pocket'

        // Swap Images
        images.forEach(img => {
          if (img.classList.contains('io-img-' + mode)) {
            img.classList.add('is-visible');
          } else {
            img.classList.remove('is-visible');
          }
        });

        // Hide/Show Features based on visibility setting
        // Hide/Show Features based on visibility setting
        dots.forEach((dot, i) => {
          const vis = dot.dataset.visibility;
          
          // Generalized Logic: Hide it if it isn't meant for "both" (all shirts) 
          // AND the setting doesn't match the current active shirt mode.
          const isHidden = (vis !== 'both' && vis !== mode);
          
          if(isHidden) {
            dot.classList.add('is-hidden');
            accordions[i].classList.add('is-hidden');
            dot.classList.remove('is-active');
            accordions[i].classList.remove('is-active');
          } else {
            dot.classList.remove('is-hidden');
            accordions[i].classList.remove('is-hidden');
          }
        });

        // Automatically activate the first visible feature of the new shirt
        const firstVisibleDot = section.querySelector('.io-hotspot-dot:not(.is-hidden)');
        if(firstVisibleDot) {
           activateHotspot(firstVisibleDot.getAttribute('data-index'), false);
        }
      });
    });

    // 4. INITIALIZE ON PAGE LOAD
    // Find whichever toggle button is set as active in the HTML and simulate a click
    const activeToggle = section.querySelector('.io-toggle-btn.is-active');
    if (activeToggle) {
      activeToggle.click();
    }

  });
});